import request from '@/utils/request'

//   客房接口：
// 新增房型 post room/createRoomType，参数：
// title // 标题
// typehood // 固定传1
// avatar // 封面
// imageList // 轮播图列表,[]
// text // 备注
// order // 排序
// branchId // 分店Id
export function createRoomType(data) {
    return request({
      url: '/room/createRoomType',
      method: 'post',
      data,
    })
  }

// 修改房型 post room/updateRoomType，参数：
// roomTypeId // ID
// title // 标题
// typehood // 固定传1
// avatar // 封面
// imageList // 轮播图列表,[]
// text // 备注
// order // 排序
// step // 状态，1：待上架，2：已上架
export function updateRoomType(data) {
    return request({
      url: '/room/updateRoomType',
      method: 'post',
      data,
    })
  }
// 删除房型 post room/removeRoomType, 参数：
// roomTypeId // ID
export function removeRoomType(data) {
    return request({
      url: '/room/removeRoomType',
      method: 'post',
      data,
    })
  }
// 获取单个房型 get room/findRoomType,参数：
// roomTypeId // ID
export function findRoomType(params) {
    return request({
      url: '/room/findRoomType',
      method: 'get',
      params,
    })
  }
// 获取房型列表 get room/findRoomTypeList，参数：
// page
// size
// typehood // 固定传1
// keyword // 搜索标题
// step // 状态，1：待上架，2：已上架
// branchId // 分店ID
export function findRoomTypeList(params) {
    return request({
      url: '/room/findRoomTypeList',
      method: 'get',
      params,
    })
  }
// 新增房价码 create room/createRateCode，参数：
// title // 标题
// typehood // 类型，1：个人，2：协议公司
// text // 备注
// order // 排序
// branchId // 分店id
export function createRateCode(data) {
    return request({
      url: '/room/createRateCode',
      method: 'post',
      data,
    })
  }
// 修改房价码 update room/updateRateCode，参数：
// rateCodeId // ID
// title // 标题
// text // 备注
// order // 排序
// step // 状态，1：待上架，2：已上架
export function updateRateCode(data) {
    return request({
      url: '/room/updateRateCode',
      method: 'post',
      data,
    })
  }
// 删除房价码 update room/removeRateCode，参数：
// rateCodeId // ID
export function removeRateCode(data) {
    return request({
      url: '/room/removeRateCode',
      method: 'post',
      data,
    })
  }
// 获取单个房价码 get room/findRateCode, 参数：
// rateCodeId // ID
export function findRateCode(params) {
    return request({
      url: '/room/findRateCode',
      method: 'get',
      params,
    })
  }
// 获取房价码列表 get room/findRateCodeList, 参数：
// page
// size
// keyword // 搜索标题
// typehood // 类型
// step // 状态
export function findRateCodeList(params) {
    return request({
      url: '/room/findRateCodeList',
      method: 'get',
      params,
    })
  }
// 获取所有房价码 get room/findRateCodeAll, 参数：
// keyword // 搜索标题
// typehood // 类型
// step // 状态
export function findRateCodeAll(params) {
    return request({
      url: '/room/findRateCodeAll',
      method: 'get',
      params,
    })
  }
// 设置房价 post room/setupRate，参数：
// rateList // 房价列表：[{
// rateCodeId // 房价码ID
// roomTypeId // 房型ID
// date // 日期，YYYY-MM-DD
// rate // 房价
// }]
export function setupRate(data) {
    return request({
      url: '/room/setupRate',
      method: 'post',
      data,
    })
  }
// 获取房价列表 get room/findRateList，参数：
// rateCodeId // 房价码ID
// roomTypeId // 房型ID
// startDate // 开始日期，YYYY-MM-DD
// endDate // 结束日期，YYYY-MM-DD
export function findRateList(params) {
    return request({
      url: '/room/findRateList',
      method: 'get',
      params,
    })
  }
// 设置房量 post room/setupVolume，参数：
// volumeList // 房量列表,[{
// roomTypeId // 房型ID
// date // 日期，YYYY-MM-DD
// volume // 房量
// state // 状态，1：正常，2：关房
// }]
export function setupVolume(data) {
    return request({
      url: '/room/setupVolume',
      method: 'post',
      data,
    })
  }
// 获取房量列表 get room/findVolumeList，参数：
// roomTypeId // 房型ID
// startDate // 开始日期，YYYY-MM-DD
// endDate // 结束日期，YYYY-MM-DD
export function findVolumeList(params) {
    return request({
      url: '/room/findVolumeList',
      method: 'get',
      params,
    })
  }
// 协议公司接口：
// 新增协议公司 post contractCompany/createContractCompany，参数：
// title // 标题
// contractList // 签约列表，[{branchId//分店ID,rateCode//房价码}]
// startDate // 开始日期，YYYY-MM-DD
// endDate // 结束日期，YYYY-MM-DD
// createPeopleId // 签约销售员工ID
// followPeopleId // 维护销售员工ID
// text // 备注
// order // 排序
export function createContractCompany(data) {
    return request({
      url: '/contractCompany/createContractCompany',
      method: 'post',
      data,
    })
  }
// 修改协议公司 post contractCompany/updateContractCompany，参数：
// contractCompanyId // ID
// title // 标题
// contractList // 签约列表，[{branchId//分店ID,rateCode//房价码}]
// startDate // 开始日期，YYYY-MM-DD
// endDate // 结束日期，YYYY-MM-DD
// createPeopleId // 签约销售员工ID
// followPeopleId // 维护销售员工ID
// text // 备注
// order // 排序
// step // 状态，1：已生效，2：待生效
export function updateContractCompany(data) {
    return request({
      url: '/contractCompany/updateContractCompany',
      method: 'post',
      data,
    })
  }
// 删除协议公司 post contractCompany/removeContractCompany，参数：
// contractCompanyId // ID
export function removeContractCompany(data) {
    return request({
      url: '/contractCompany/removeContractCompany',
      method: 'post',
      data,
    })
  }
// 获取单个协议公司 get contractCompany/findContractCompany，参数：
// contractCompanyId // ID
export function findContractCompany(params) {
    return request({
      url: '/contractCompany/findContractCompany',
      method: 'get',
      params,
    })
  }
// 获取协议公司列表 get contractCompany/findContractCompanyList，参数：
// page
// size
// keyword // 搜索标题/备注
// createPeopleId // 按签约销售员工搜索
// followPeopleId // 按维护销售员工搜索
// step // 状态，1：已生效，2：待生效
export function findContractCompanyList(params) {
    return request({
      url: '/contractCompany/findContractCompanyList',
      method: 'get',
      params,
    })
  }
// 新增订房人 post contractCompany/createBooker, 参数：
// contractCompanyId // 协议公司ID
// peopleId // 订房人用户ID
export function createBooker(data) {
    return request({
      url: '/contractCompany/createBooker',
      method: 'post',
      data,
    })
  }
// 删除订房人 post contractCompany/removeBooker, 参数：
// bookerId // 订房人ID
export function removeBooker(data) {
    return request({
      url: '/contractCompany/removeBooker',
      method: 'post',
      data,
    })
  }
// 获取单个订房人 get contractCompany/findBooker, 参数：
// bookerId // 订房人ID
export function findBooker(params) {
    return request({
      url: '/contractCompany/findBooker',
      method: 'get',
      params,
    })
  }
// 获取订房人列表 get contractCompany/findBookerList, 参数：
// page
// size
// contractCompanyId // 协议公司ID
// peopleId // 订房人用户ID
export function findBookerList(params) {
    return request({
      url: '/contractCompany/findBookerList',
      method: 'get',
      params,
    })
  }

  // findRateAll,
  export function findRateAll(params) {
    return request({
      url: '/room/findRateAll',
      method: 'get',
      params,
    })
  }
  // findVolumeAll
  export function findVolumeAll(params) {
    return request({
      url: '/room/findVolumeAll',
      method: 'get',
      params,
    })
  }

  // 酒店接口
//   新增酒店：post room/createHotel，参数：
// title // 标题
// avatar // 封面
// imageList // 轮播图
// address // 地址
// lat // 纬度
// lng // 经度
// tel // 联系电话
// openDate // 开业日期
// desc // 简介文字
// tagList // 标签列表，['经济型','快捷酒店']
// tipList // 酒店政策，[{title// 标题，text//内容}]
// facilityList // 酒店设施，[{icon//图标，title//名称}]
// text // 备注
// order // 排序
// branchId // 分店ID
export function createHotel(data) {
  return request({
    url: '/room/createHotel',
    method: 'post',
    data,
  })
}
// 修改酒店：post room/updateHotel，参数：
// hotelId // 酒店ID
// title // 标题
// avatar // 封面
// imageList // 轮播图
// address // 地址
// lat // 纬度
// lng // 经度
// tel // 联系电话
// openDate // 开业日期
// desc // 简介文字
// tagList // 标签列表，['经济型','快捷酒店']
// tipList // 酒店政策，[{title// 标题，text//内容}]
// facilityList // 酒店设施，[{icon//图标，title//名称}]
// text // 备注
// order // 排序
export function updateHotel(data) {
  return request({
    url: '/room/updateHotel',
    method: 'post',
    data,
  })
}
// 删除酒店：post room/removeHotel,参数：
// hotelId // 酒店ID
export function removeHotel(data) {
  return request({
    url: '/room/removeHotel',
    method: 'post',
    data,
  })
}
// 获取单个酒店：get room/findHotel,参数：
// hotelId // 酒店ID
export function findHotel(params) {
  return request({
    url: '/room/findHotel',
    method: 'get',
    params,
  })
}
// 获取酒店列表：get room/findHotelList, 参数：
// page
// size
// keyword // 搜索标题
// step // 搜索状态，1：待上架，2：已上架
export function findHotelList(params) {
  return request({
    url: '/room/findHotelList',
    method: 'get',
    params,
  })
}